import { useState, useMemo } from 'react';

function useDateRangePicker(
	initialStartDate,
	initialEndDate,
	initialDisabledDates = [],
) {
	const [startDate, setStartDate] = useState(setStartOfDay(initialStartDate));
	const [endDate, setEndDate] = useState(setEndOfDay(initialEndDate));
	const [disabledDates, setDisabledDates] = useState(initialDisabledDates);

	const setStart = (date) => {
		setStartDate(date);
		if (endDate && date && date > endDate) {
			setEndDate(undefined);
		}
	};

	const setEnd = (date) => {
		if (startDate && date < startDate) {
			setEndDate(startDate);
		} else {
			setEndDate(date);
		}
	};

	const startDisabledDates = useMemo(
		() => [...disabledDates, { after: endDate }],
		[disabledDates, endDate],
	);

	const endDisabledDates = useMemo(
		() => [...disabledDates, { before: startDate }],
		[disabledDates, startDate],
	);

	function setStartOfDay(date) {
		const newDate = new Date(date);
		newDate.setHours(0, 0, 0, 0);
		return newDate;
	}

	function setEndOfDay(date) {
		const newDate = new Date(date);
		newDate.setHours(23, 59, 59, 999);
		return newDate;
	}

	return {
		startDate,
		endDate,
		setStart: (date) => {
			setStart(setStartOfDay(date));
		},
		setEnd: (date) => {
			setEnd(setEndOfDay(date));
		},
		startDisabledDates,
		endDisabledDates,
		setDisabledDates,
	};
}

export default useDateRangePicker;
